(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientGroupController', PatientGroupController);

    PatientGroupController.$inject = ['PatientGroup', 'PatientGroupSearch', 'clinic'];

    function PatientGroupController(PatientGroup, PatientGroupSearch, clinic) {

        var vm = this;

        vm.patientGroups = [];
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;

        loadAll();

        function loadAll() {
            PatientGroup.getAllByClinic({id : clinic.id}, function(result) {
                vm.patientGroups = result;
                vm.searchQuery = null;
            });
        }

        function search() {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            PatientGroupSearch.query({query: vm.searchQuery}, function(result) {
                vm.patientGroups = result;
                vm.currentSearch = vm.searchQuery;
            });
        }

        function clear() {
            vm.searchQuery = null;
            loadAll();
        }    }
})();
